export default __webpack_public_path__ + "static/media/QuATRo_Siegel_2022_Gruen.6e2a5770.svg";